import React, { useEffect, useState } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import moment from 'moment';
import { Box } from '../styles/globalStyle';
import { DownloadOutlined } from '@ant-design/icons';
import RenderDatePicker from '../common/components/datePicker';
import { Space, Form, Divider, Tooltip, Modal as antmodal, Row } from 'antd';
import CaretImg from '../assets/images/vector.svg';
import { useSelector } from 'react-redux';
import { groupByProperty } from '../utils/common';
import { sizes } from '../styles/mediaQuery';
import { useHistory } from 'react-router-dom';
import { PayeeInstructionsAuditReportDownload } from '../actions/actions';
import {
  theme,
  ButtonAnt,
  SelectComponent,
  InputComponent
} from '@pfmam/pfmam';

const LocalContainer = styled.div`
  @media ${sizes.mediaQuery('xs', 'xxl')} {
    width: 100%;
    padding-left: 32px;
    padding-right: 32px;
  }
  @media ${sizes.mediaQuery('xxl')} {
    max-width: 1400px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    padding-left: 0;
    padding-right: 0;
  }
  @media ${sizes.mediaQuery('xs', 'xl')} {
    padding-left: 40px;
    padding-right: 40px;
  }
`;

const Wrapper = styled.div`
  padding-top: 22px;
`;

const FilterCol = styled(Space)`
  flex: 1;
  white-space: nowrap;
  overflow: ${(props) => (props.overflow ? 'hidden' : '')};
`;

const OverrideStyle = createGlobalStyle`
   .ant-input {
       height: 52px;
       width: 200px;
       line-height: 20px;
       font-size: ${theme.font_size.size_xl};
       color: ${theme.colors.black_secondary};
     }
  .ant-form-item-control-input-content {
    & > span {
      width: 200px;
    }
    .primary.ant-select-single:not(.ant-select-customize-input) {
      .ant-select-selector {
        height: 52px;
        width: 200px;
        background: ${theme.colors.white};
        color: ${theme.colors.black_secondary};
        border: 1px solid ${theme.colors.grey};
        padding: 14px 20px;
        .ant-select-selection-item,
        .ant-select-selection-placeholder {
          line-height: 20px;
        }
        .ant-select-selection-search-input {
          height: 100%;
        }
      }
      .ant-select-arrow {
        color: ${theme.colors.grey_stone};
        font-size: 17px;
        margin-top: 0;
        top: 45%;
        transform: translateY(-50%);
        right: 20px;
      }
      &.ant-select-focused {
        .ant-select-selector {
          box-shadow: ${theme.shadows.input_focus};
          border-color: ${theme.colors.blue_primay};
        }
          .ant-select-arrow {
          color: ${theme.colors.black_secondary};
        }
      } 
    }
  }
  
  .form-select-dropdown {
    box-shadow:  0px 3px 6px -4px rgba(0, 0, 0, 0.12);
      .ant-select-item {
        &.ant-select-item-group {
          color: ${theme.colors.grey_tertiary};
          min-height: 22px;
          line-height: 22px;
          padding: 6px 12px;
          &:hover {
            background: none;
          }
        }
      }
      .ant-select-item-option-selected,
      .ant-select-item-option-active {
        &:not(.ant-select-item-option-disabled) {
          background: ${theme.colors.white};
          font-weight: normal;
        }
      }
      .ant-select-item {
        min-height: 36px;
        line-height: 20px;
        padding: 8px 12px;
        font-size: ${theme.font_size.size_l};
        color: ${theme.colors.black_secondary};
        font-family: 'Inter';
        &:hover {
        background: ${theme.colors.light_grey};
        font-family: 'Inter';
      }
    }
  }
  .forms {
    .ant-input {
      &.textarea {
        min-height: 108px;
      }
    }
  }
  }
`;

const DropdownWrapper = styled.div`
  
  .ant-select {
    width: 100%;
    background: ${theme.colors.white};
    color: ${theme.colors.black_secondary};
    
    .ant-select-arrow {
      color: ${theme.colors.grey_stone};
      font-size: ${theme.font_size.size_m};
      margin-top: -8px;
    }
    &.ant-select-open {
      .ant-select-selection-item {
        color: ${theme.colors.grey_stone};
        font-weight: ;
      }
    }
    .ant-select-selector {
      height: 100%;
    }
    &.ant-select-focused {
      box-shadow: ${theme.shadows.input_focus};
      border-color: ${(props) => props.linkTextColor};
    }
    .anticon-down {
      position: relative;
      svg {
        display: none;
      }
      &:after {
        content: '';
        display: block;
        background-image: url(${CaretImg});
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        display: block;
        width: 10px;
        height: 8px;
        visibility: visible;
        position: absolute;
        right: -5px;
        top: 2px;
        z-index: 2;
      }
    }
  }
  & > span,
  .ant-select,
  .ant-select-single:not(.ant-select-customize-input)
    .ant-select-selector
    .ant-select-selection-search-input {
    height: 100%;
  }
  .ant-select-dropdown {
    box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
      0px 6px 16px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
    .ant-select-item {
      &.ant-select-item-group {
        color: ${theme.colors.grey_tertiary};
        min-height: 16px;
        line-height: 16px;
        padding: 6px 12px;
        &:hover {
          background: none;
        }
      }
    }
    .ant-select-item-option-selected,
    .ant-select-item-option-active {
      &:not(.ant-select-item-option-disabled) {
        background: ${theme.colors.grey_faint};
        font-weight: normal;
      }
    }
    .ant-select-item {
      min-height: 34px;
      line-height: 20px;
      padding: 7px 12px;
      color: ${theme.colors.black_secondary};
      font-family: 'Inter';
      &:hover {
        background: ${theme.colors.grey_faint};
        font-family: 'Inter';
      }
    }
  }
`;

const PayeeInstructionsReportContainer = (props) => {
  const history = useHistory();
  const [dateValues, setDateValues] = useState([
    moment().subtract(60, 'days'),
    moment(),
  ]);
  const [dateOption, setDateOption] = useState('last60days');
  const [dateLabel, setDateLabel] = useState('Last 60 days');
  const [dateOpen, setDateOpen] = useState(false);
  const primary_color = useSelector((state) => state.siteInfo.primaryColor);
  const [tooltip, setTooltip] = useState(false);
  const [instructionType, setInstructionType] = useState(null);
  const [applicationType, setApplicationType] = useState(null);
  const [selectedClient, setSelectedClient] = useState(null);
  const clientPrograms = useSelector(
    (state) => state.programsClientsSlice.programClients
  );
  const webuserAccessType = useSelector((state) => state.userSlice.webUserType);
  const [submitted, setSubmitted] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  useEffect(() => {
    setStartDate(dateValues[0].format('YYYY-MM-DD'));
    setEndDate(dateValues[1].format('YYYY-MM-DD'));
  }, []);

  if (webuserAccessType == 0) {
    history.push("/404");
  }
  const [form] = Form.useForm();

  const handleError = (err) => {
    console.log(err);
    antmodal.warning({
      title: 'There was an error processing the request. Please try again.',
      okText: 'Ok',
      onOk: () => {
        history.push("/dashboard");
      },
    });
  };

  const handleDateChange = () => {
    setStartDate(dateValues[0].format('YYYY-MM-DD'));
    setEndDate(dateValues[1].format('YYYY-MM-DD'));
  };

  const applicationDropDownOnChange = (value) => {
    setApplicationType(value);
  };

  const instructionTypeDropDownOnChange = (value) => {
    setInstructionType(value);
  };

  const clientdropDownOnChange = (value) => {
    let selectClientDropdown = [];
    if (value.includes('~')) {
      var fields = value.split('~');
      selectClientDropdown = clientPrograms.filter(
        (x) =>
          x.clientname.toLowerCase().includes(fields[0].toLowerCase()) &&
          x.programname.includes(fields[1]) &&
          x.ssnortin.includes(fields[2])
      );
    } else {
      selectClientDropdown = clientPrograms.filter((x) =>
        x.clientname.toLowerCase().trim() == value.toLowerCase().trim()
      );
    }
    setSelectedClient(selectClientDropdown[0]);
  };


  const downloadOnClick = () => {
    setSubmitted(true);
    var date = new Date();
    if (applicationType == null || instructionType == null) {
      antmodal.warning({
        title: 'Application Type and Instruction Type are required',
        okText: 'Ok',
        //onOk: noAccountLinkedOk
      });
    } else {
      PayeeInstructionsAuditReportDownload(instructionType, selectedClient?.ssnortin, document.getElementById('accNumber').value, startDate,
        endDate, applicationType).then((response) => {
          if (response.data == "No Data Found!") {
            setSubmitted(false);
            antmodal.warning({
              title: 'No data found for the current selection!',
              okText: 'Ok',
            });
          } else {
            const arrayBuffer = base64ToArrayBuffer(response.data);
            createAndDownloadBlobFile(arrayBuffer, instructionType + 'Instructions_' + moment(date).format('YYYYMMDD'));
            setSubmitted(false);
          }
        }).catch((error) => {
          setSubmitted(false);
          handleError(error);
        });
    }
  };

  function base64ToArrayBuffer(base64) {
    const binaryString = window.atob(base64); // Comment this if not using base64
    const bytes = new Uint8Array(binaryString.length);
    return bytes.map((byte, i) => binaryString.charCodeAt(i));
  }

  function createAndDownloadBlobFile(body, filename, extension = 'pdf') {
    const blob = new Blob([body]);
    const fileName = `${filename}.${extension}`;
    if (navigator.msSaveBlob) {
      // IE 10+
      navigator.msSaveBlob(blob, fileName);
    } else {
      const link = document.createElement('a');
      // Browsers that support HTML5 download attribute
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }

  return (
    <>
      <OverrideStyle />
      <LocalContainer>
        <Wrapper>
          <Row>
            <Box
              margin="0 0 24px 0"
              display="flex"
              justifycontent="space-between"
              alignitems="center"
              minwidth="100%"
              width="100%"
            >
              <FilterCol size={24} overflow={true}>
                <DropdownWrapper
                  linkTextColor={primary_color}
                >
                  <Form.Item>
                    <SelectComponent
                      placeholder="Application"
                      option={[
                        {
                          label: 'Access 360',
                          value: 'Access 360',
                        },
                        {
                          label: 'Connect',
                          value: 'Connect',
                        },
                        {
                          label: 'Both',
                          value: 'Both',
                        },
                      ]}

                      color={`${theme.colors.black_secondary}`}
                      bordered={true}
                      onChange={(value) => applicationDropDownOnChange(value)}
                      dropdownRender={(menu) => (
                        <>
                          {menu}
                        </>
                      )}
                    />
                  </Form.Item>
                </DropdownWrapper>


                <DropdownWrapper
                  linkTextColor={primary_color}
                >
                  <Form.Item>
                    <SelectComponent
                      placeholder="Type"
                      option={[
                        {
                          label: 'ACH',
                          value: 'ACH',
                        },
                        {
                          label: 'WIRE',
                          value: 'WIRE',
                        },
                      ]}

                      color={`${theme.colors.black_secondary}`}
                      bordered={true}
                      onChange={(value) => instructionTypeDropDownOnChange(value)}
                      dropdownRender={(menu) => (
                        <>
                          {menu}
                        </>
                      )}
                    />
                  </Form.Item>
                </DropdownWrapper>

                {clientPrograms.length > 1 ? (
                  <DropdownWrapper
                    linkTextColor={primary_color}
                    id="multiple-programs-dropdown1"
                  >
                    <Form.Item>
                      <SelectComponent
                        placeholder="Select Client"
                        option={groupByProperty(clientPrograms, 'programname')}
                        color={`${theme.colors.black_secondary}`}
                        display="groupBy"
                        getPopupContainer={() =>
                          document.getElementById('multiple-programs-dropdown1')
                        }
                        bordered={true}
                        onChange={(value) => clientdropDownOnChange(value)}
                        showSearch
                        dropdownRender={(menu) => (
                          <>
                            {menu}
                          </>
                        )}
                      />
                    </Form.Item>
                  </DropdownWrapper>
                ) : null}


                <Form.Item name="accNumber">
                  <InputComponent
                    id="accNumber"
                    style={{ borderColor: theme.colors.grey }}
                    maxLength={20}
                    placeholder="Account Number"
                  />
                </Form.Item>

                <RenderDatePicker
                  dateValues={dateValues}
                  setDateValues={setDateValues}
                  dateOption={dateOption}
                  setDateOption={setDateOption}
                  dateLabel={dateLabel}
                  setDateLabel={setDateLabel}
                  dateOpen={dateOpen}
                  setDateOpen={setDateOpen}
                  handleDateChange={handleDateChange}
                />


              </FilterCol>

              <Box display="flex" alignitems="center">
                <Divider type="vertical" className="filter-divider" />
                <Tooltip
                  placement="top"
                  title="Download"
                  overlayClassName="tooltip"
                  visible={tooltip}
                >
                  <ButtonAnt
                    icon={<DownloadOutlined />}
                    label={'Download'}
                    type="secondary"
                    onClick={downloadOnClick}
                    onMouseEnter={() =>
                      setTooltip(true)
                    }
                    onMouseLeave={() => setTooltip(false)}
                    loading={submitted}
                  />
                </Tooltip>
              </Box>

            </Box>
          </Row>
        </Wrapper>
      </LocalContainer>
    </>
  );

};

export default PayeeInstructionsReportContainer;